import { cn, withSelector } from '@solinkcorp/solink-ui';

// ============================================
// Shared SDM Dropdown Styles
// Used by: LayoutSelector, SiteSelector
// ============================================

/** Base styles for dropdown list items with bottom border */
export const sdmListItemStyles = cn(`
  cursor-pointer
  border-b
  border-l-0
  border-r-0
  border-t-0
  border-solid
  border-b-input
  py-[0.75rem]
  last:border-b-0
  text-text-primary
`);

/** Selected/active state for dropdown list items */
export const sdmSelectedItemStyles = cn(`
  !border-l-[3px]
  !border-l-primary
  hover:!bg-foreground-accent
  bg-foreground-accent
  text-interaction-primary-content-default
  hover:!text-interaction-primary-content-default
`);

export const sdmOutlineBtnStyles = cn(`
  cursor-pointer
  hover:bg-ui-modal-darker-inner-section 
  border 
  border-turquoise-500 
  bg-transparent 
  text-turquoise-500 
  hover:!text-turquoise-500 
  hover:opacity-75 
  dark:bg-transparent 
  dark:text-sdm-highlight 
  dark:hover:bg-accent/50
`);

export const sdmCancelBtnStyles = cn(`
  cursor-pointer
  bg-transparent 
  text-muted-foreground 
  border-muted-foreground/50 
  hover:bg-muted 
  hover:text-foreground 
  dark:text-white
`);

/** SDM dialogs sit on `background-surface` rather than Dialog's default `background`. */
export const sdmDialogContentStyles = cn('bg-background-surface');

// ============================================
// Layout Selector Specific Styles
// ============================================

/** Layout selector list item - extends sdmListItemStyles with layout-specific styles */
export const baseLayoutStyles = `${sdmListItemStyles} ${cn(`
  flex
  min-w-[300px]
  max-w-[350px]
  items-center
  justify-between
  rounded-sm
  text-sm
  hover:bg-accent
  cursor-pointer
`)}`;

export const actionTextStyles = cn(`
  font-normal
  text-base
  leading-normal
  text-muted-foreground
`);

export const ellipsisTextStyle = cn(`
  text-ellipsis
  overflow-hidden
  whitespace-nowrap
`);

export const dropDownMenuSubTriggerStyles = cn(`
  group rounded p-1
  hover:!bg-sdm-highlight
  data-[state=open]:!bg-sdm-highlight
  [&>svg:last-child]:hidden
  ml-2
  mr-4
`);

export const ellipsisVerticalStyles = cn(`
  size-4
  cursor-pointer 
  group-hover:text-white 
  group-data-[state=open]:text-white
`);

export const dropDownMenuTriggerStyles = cn(`
  inline-flex
  max-w-[350px]
  min-w-[300px]
  gap-2
  text-sm
  rounded-md
  border
  border-border-muted
  bg-background-surface
  px-3
  py-1.5
  cursor-pointer
  hover:bg-[#ffffffd4]
  dark:bg-card
  dark:hover:bg-accent/50
  [&>div]:flex
  [&>div]:w-full
  [&>div]:justify-between
  [&>div]:items-center
`);

export const layoutLabelContainerStyles = cn(`
  flex
  items-baseline
  gap-1
`);

export const layoutLabelStyles = cn(`
  text-[0.6875rem]
  font-medium
  uppercase
  tracking-wide
`);

export const layoutNameStyles = cn(`
  max-w-[250px]
  font-medium
  text-muted-foreground
  dark:text-white
  text-ellipsis
  text-left
  overflow-hidden
  whitespace-nowrap

`);

export const dropDownMenuItemNewLayoutStyles = cn(`
  h-fit
  grow
  cursor-pointer
  justify-start
  gap-0
  border-none
  bg-transparent
  dark:bg-transparent
  hover:dark:bg-transparent
  text-text-primary
`);

// Apply hover styles to menuitem children //
export const menuItemActionSelector = '[&_[role=menuitem]]';
export const menuItemActionHoverSelector = '[&_[role=menuitem]:hover]';
export const menuItemActionStyles = [
  withSelector(
    menuItemActionHoverSelector,
    'bg-sdm-highlight/10 border-l-[3px] border-l-sdm-highlight border-solid',
  ),
  withSelector(menuItemActionSelector, 'border-t-0 border-r-0 border-b-0'),
].join(' ');
